import { ImpersonationGrantLevel } from "@wingspanhq/wingspan-api-sdk";
import * as Yup from "yup";

/**
 * Mirrors the spec's `AccountId`: new V3 accounts use a 22-character Wingspan
 * id, accounts migrated from v1 may still carry a 24-character Mongo ObjectId.
 */
const ACCOUNT_ID_PATTERN = /^(?:[A-Za-z0-9_.]{22}|[a-f0-9]{24})$/;

export const validationSchemaImpersonate = Yup.object().shape({
  targetAccountId: Yup.string()
    .required("Account ID is required")
    .matches(ACCOUNT_ID_PATTERN, "Enter a valid 22 or 24 character account ID"),
  level: Yup.string()
    .required("Access level is required")
    .oneOf(Object.values(ImpersonationGrantLevel)),
  reason: Yup.string().required("Reason is required")
});
